import { render } from "./AccountDropdown.vue?vue&type=template&id=43be5f42&scoped=true"
import script from "./AccountDropdown.vue?vue&type=script&lang=js"
export * from "./AccountDropdown.vue?vue&type=script&lang=js"

import "./AccountDropdown.vue?vue&type=style&index=0&id=43be5f42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43be5f42"]])

export default __exports__